onReady(async ($) => {
    var scrollNotified = false;
    // Adds scrolling shadow to bottom of nav
    var navContainer = $(".navigationcontainer, .landing-page-nav");

    function observeNavContainerScrolling() {
        navContainer.toggleClass("scrolling", $(window)
            .scrollTop() > 10);
        if (!scrollNotified && window.scrollY > 100) {
            scrollNotified = true;
            $('body')
                .trigger({type: 'user-scrolled'});
        }
    }

    $(window)
        .scroll(observeNavContainerScrolling);
    observeNavContainerScrolling();

    // Back button within mobile nav
    var $backBtn = $('#navigation-wrapper .back');
    $backBtn.on('click', (e) => {
        e.preventDefault();
        $backBtn.removeClass('active');
        $('div.drop-nav.opened')
            .removeClass('opened');
    });
    $('div.drop-nav')
        .each((i, dropNav) => {
            const nav = $(dropNav);
            nav.on('click', () => {
                if (window.matchMedia('only screen and (max-width: 1199px)').matches) {
                    nav.addClass('opened');
                    $backBtn.addClass('active');
                }
            });
        });

    // Open and close mobile nav
    function openMobileNav() {
        $("#navigation-mobile,.navigation__mobile--backdrop")
            .addClass('open');
        $(".navigation-mobile__full")
            .addClass('reveal');
        $("#hamburger-icon")
            .addClass('active');
        $("body")
            .addClass("nav-open");
        setTimeout(() => $("html,body")
            .addClass('freeze'), 500);
    }

    function closeMobileNav() {
        $("#hamburger-icon")
            .removeClass('active');
        $("html,body")
            .removeClass('freeze');
        $("#navigation-mobile,.navigation__mobile--backdrop")
            .removeClass('open');
        $(".navigation-mobile__full")
            .removeClass('reveal');
        $("body")
            .removeClass("nav-open");
        $('div.drop-nav.opened')
            .removeClass('opened');
        $backBtn.removeClass('active');
    }

    $('#navigation-mobile__control')
        .on('click', async () => {
            await yieldToMain()

            if ($("#hamburger-icon")
                .hasClass('active')) {
                closeMobileNav();
            }
            else {
                openMobileNav();
            }
        });

    const ctaButtons = Array.from(document.querySelectorAll('.menu-actions a'))
    for (const ctaButton of ctaButtons) {
        ctaButton.addEventListener('click', (event) =>
            dataLayer.push({
                event: 'cta-click',
                interactionType: 'click',
                moduleName: 'Top Nav',
                elementContent: ctaButton.textContent.replace("\n", '')
                    .trim(),
                elementType: ctaButton.nodeName,
                elementClasses: ctaButton.classList.toString() || 'sign-in',
                destinationUrl: ctaButton.href,
                modulePosition: 0,
                distinctModulePosition: 1,
                moduleTabPosition: 0,
                moduleId: 'top_nav',
                wpLoggedIn: document.body.classList.contains('logged-in')
                    .toString(),
            }),
        )
    }

    await yieldToMain()

    // Move menu content to mobile/desktop container
    function navDOMRelocation() {
        if (window.matchMedia('only screen and (max-width: 991px)').matches) {
            $('.menu-primary__wrapper')
                .addClass('hidden')
                .appendTo('.navigation-mobile__full');
            $('.menu-primary__wrapper .menu-actions')
                .addClass('hidden')
                .addClass('mobile-menu-actions')
                .appendTo('body');
            setTimeout(() => $('.menu-primary__wrapper, .mobile-menu-actions')
                .removeClass('hidden'), 100);
        }
        else {
            $('.menu-primary__wrapper')
                .appendTo('#navigation-wrapper');
            $('body .mobile-menu-actions')
                .removeClass('mobile-menu-actions')
                .appendTo('#navigation-wrapper .menu-primary__wrapper');

            if ($("#navigation-mobile")
                .hasClass("open")) {
                $("#navigation-mobile,.navigation__mobile--backdrop")
                    .removeClass('open');
                $("html,body")
                    .removeClass('freeze');
            }
        }
    }

    navDOMRelocation();
    $(window)
        .on('resize', navDOMRelocation);
});
